(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dps-collection-subfilters"] && !Shopify.designMode) return;
  try {
    function revealPortraitFilters() {
    document.querySelectorAll('.dps-collection-navigation__scroll, .dps-collection-subfilters').forEach((navigation) => {
      const active = navigation.querySelector('[aria-current="page"]');
      if (!active || navigation.scrollWidth <= navigation.clientWidth) return;
      const item = active.getBoundingClientRect();
      const viewport = navigation.getBoundingClientRect();
      navigation.scrollLeft += item.left - viewport.left + item.width / 2 - navigation.clientWidth / 2;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealPortraitFilters, { once: true });
  else revealPortraitFilters();
  document.addEventListener('shopify:section:load', revealPortraitFilters);
  } catch(e) { console.error(e); }
})();

})();
